import { render, staticRenderFns } from "./SearchCompanyCard.vue?vue&type=template&id=1a1a29e6&"
import script from "./SearchCompanyCard.vue?vue&type=script&lang=ts&"
export * from "./SearchCompanyCard.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCompanyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports